<template>
	<div>
	<div :class="{'co-extra-container': !showInShippingAddress}">
		<div class="co-extra-block">
			<h4 v-if="!showInShippingAddress">{{ data.title }}</h4>
			<with-root :show-if="showInShippingAddress">
				<v-layout>
					<div class="co-extra-icon" v-if="showInShippingAddress">
							<v-icon>error</v-icon>
					</div>
					<with-root :show-if="showInShippingAddress">
						<div class="co-extra-text">
							<p v-if="data.shipping_tips">
								<template v-if="data.shipping_tips['campus_address']">
									<strong class="co-text-highlight">To ship to your campus, use this address:</strong><br>
									<span v-html="formatAddress(data.shipping_tips['campus_address'], '<br>')"></span>
								</template>
							</p>

							<p v-if="data.show_apo_warning" v-bind="ADAattr('focus')">
								<strong>Important:</strong> <span v-html="data.rental_apo_text"></span>
							</p>

							<p v-if="data.enabled_flexpay" v-bind="ADAattr('focus')">
								<strong class="co-text-highlight">Important:</strong> The Grand Total does not include sales/use tax charges, but these charges will be reflected correctly in Launchpad.
							</p>

							<p v-if="data.require_cc_to_secure_rental" v-bind="ADAattr('focus')">
								<strong>Important:</strong> We require a valid credit card to secure your rental return.
							</p>

							<p v-if="data.disable_international_shipping" v-bind="ADAattr('focus')">
								<strong>Important:</strong> <span v-html="data.disabled_international_shipping_text"></span>
							</p>

							<p v-if="data.show_po_box_notice && data.school_domain != 'valenciacollege'">
								If you enter a PO Box, you will not be able to choose UPS shipping for your order
							</p>

							<p v-if="data.school_domain == 'valenciacollege'">
								If you ship to the VC Vault, you will receive an email and text once the order is ready for pickup. If
								you enter a PO Box, you will not be able to choose UPS shipping for your order.
							</p>

              <p v-if="data.school_domain == 'rit'">
                Note: If you are attempting to checkout with a residence hall address that is longer than 24 characters, please use the below example to successfully checkout:
                <br>
                <br>
                Address Line 1: Building Room # <br>
                Address Line 2: 5000 Nathaniel Roch Hall
							</p>

							<p v-if="data.school_domain == 'rockford'">
							  If you ship to campus, remember to include your CPO box number in your shipping address
							</p>

							<p v-if="data.school_domain == 'goshen'">
							  If you are a new student at Goshen College, please email <a href="maito:campuspost@goshen.edu">campuspost@goshen.edu</a> and let them know you are sending your books to campus.
							</p>

							<p v-if="data.school_domain == 'ferris'">
								If you ship to your on campus residence, remember to include your residence hall and room number in your shipping address. DO NOT SHIP to residence halls more than one week in advance of move in.<br>
								<br><b>No secure place to ship to?</b>
								For Big Rapids campus, email Lauren Hitt at <a href="mailto:laurenhitt@ferris.edu">laurenhitt@ferris.edu</a> for assistance.
								For KCAD campus, email Mikayla Portee at <a href="mailto:mikaylaportee@ferris.edu">mikaylaportee@ferris.edu</a> for assistance.
							</p>

							<p v-if="data.school_domain == 'unk'">
								<b>Campus Delivery:</b><br>
								Students who deliver their textbooks and course materials to the Loper Spirit Shop, the campus pick-up location, must pick up their packages by the final day of the semester. Textbooks and course materials not picked up after this date will be considered abandoned.<br>
								<a href="https://www.unk.edu/about/compliance/files/unk-abandoned-book-policy.pdf" target="_blank">Review the full Abandoned Book Policy</a>
							</p>

							<p v-if="data.school_domain == 'ucsc'">
								<b style="color: #BF2600">Attention Students:</b><br><br>
								If you ship to campus, please ship to your dorm room.
								The Bay Tree Campus Store is unable to accept and hold packages for students.
							</p>

							<p v-if="data.school_domain == 'fredonia'">
								Use your full name and dorm address when addressing packages to campus.<br>
								You can format the address as follows:<br><br>
								Full Name<br>
								Room number and building (EX: 900 Alumni Hall)<br>
								280 Central Ave.<br>
								Fredonia, NY 14063
							</p>

							<p v-if="data.school_domain == 'cabrillo'">
								<i>Please note, if shipping to your home address is not possible, please use the below address for shipping to campus:</i><br />
								<br />
								<b>Cabrillo College Bookstore<br />
								6500 Soquel Dr.<br />
								Aptos, CA 95003</b>
							</p>

							<p v-if="data.school_domain == 'rappahannock'">
								<i>Please note, if shipping to your home address is not possible, please use one of the two below addresses:</i><br />
								<br />
								<b>Glenns Campus Library<br />
								12745 College Dr. <br />
								Glenns, VA 23149</b><br />
								<br />
								or<br />
								<br />
								<b>Warsaw Campus Library<br />
								52 Campus Dr.<br />
								Warsaw, VA 22572</b>
							</p>

							<p v-if="checkout_tip !== ''" v-html="checkout_tip"></p>

							<p v-if="data.show_apo_delivery_warning">
								Please note that orders shipped to APO addresses may take
								longer to arrive than is listed above, and may ship without tracking. See our
								<a href="/service/shipping.php" target="_blank">shipping page</a> for more details.
							</p>

							<p v-if="data.show_weekend_delivery_notice" class="co-text-highlight">
								<strong>Please Note:</strong> No weekend delivery for students who ship their materials to campus.
							</p>
						</div>
					</with-root>
				</v-layout>
			</with-root>
		</div>
	</div>
	<div :class="{'co-extra-container': !showInShippingAddress}" v-if="data.shipping_tips && data.shipping_tips.covid_shipping_info">
		<div class="co-extra-block">
			<with-root :show-if="showInShippingAddress">
				<v-layout>
					<div class="co-extra-icon" v-if="showInShippingAddress">
						<v-icon>error</v-icon>
					</div>
					<with-root :show-if="showInShippingAddress">
						<div class="co-extra-text">
							<h4 v-if="data.shipping_tips.covid_shipping_info_title">{{ data.shipping_tips.covid_shipping_info_title }}</h4>
							<p v-html="data.shipping_tips.covid_shipping_info"></p>
						</div>
					</with-root>
				</v-layout>
			</with-root>
		</div>
	</div>
	</div>
</template>

<script>
	import {formatAddress} from './../includes/Miscellaneous';
	import WithRoot from "./WithRoot";

	export default {
		name: "ExtraCheckoutInfo",
		components: {
			'with-root': WithRoot
		},
		props: {
			data: {
				type: Object,
			},
			showInShippingAddress: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				checkout_tips: {
					'ithaca': 'If you ship to campus, remember to include your dorm address.',
					'lonestar': 'There is no longer a physical bookstore on campus.' +
						' If you ship your order to campus, you will receive information about' +
						' where to pick it up via email when it arrives and is available to pick-up.',
					// San Jose Evergreen Community College District
					'sjeccd': "<b>SJCC Shipping Tip:</b> If you use a PO Box or don't have a shipping address, please contact"
						+ ' SJCC Virtual Bookstore Support at'
						+ ' <a href="mailto:SJCCVirtualBookstore@sjcc.edu">SJCCVirtualBookstore@sjcc.edu</a>'
						+ ' to schedule an in-person appointment for help placing and receiving your order.'
						+ "<br /><b>EVC Shipping Tip:</b> If you use a PO Box or don't have a shipping address, please contact"
						+ ' EVC Virtual Bookstore Support at'
						+ ' <a href="mailto:EVCVirtualBookStore@evc.edu">EVCVirtualBookStore@evc.edu</a>'
						+ ' to schedule an in-person appointment for help placing and receiving your order.',
				}
			}
		},
		computed: {
			checkout_tip () {
				const _checkout_tip = this.checkout_tips[this.data.school_domain];
				return _checkout_tip !== undefined ? _checkout_tip : '';
			},
		},
		methods: {
			formatAddress,
		},
	}
</script>

<style scoped lang="less">
	.co-extra-container {
		border: 2px solid #DDDDDD;
		margin-left: 20px;
		margin-top: 6px;
		padding: 15px 20px;

		@media screen and (max-width:600px){
			margin-left: 4px;
		}

		h4 {
			text-align: left;
			padding: 5px 0 10px;
			color: #000 !important;
			margin: 0;
		}

		p {
			margin-top: 10px;
		}
	}

  .co-extra-text {
    padding-left: 10px;
    margin-top: 10px;

    p {
      font-size: 13px;
      font-weight: bold;
      margin-bottom: 1px;
      color: #c05321;
    }

    h4 {
      color: #c05321;
    }

    a, strong, p.co-text-highlight {
      color: #1c6ef2 !important;
    }
  }

  .co-extra-icon {
    padding-top: 11px;

    i {
      font-size: 15px;
      color: #c05321;
    }
  }
</style>
